import { Redirect } from 'react-router-dom'
import Routes from 'routes'
import React from 'react'

const Logout = () => {
  localStorage.clear()
  return <Redirect to={Routes.LOGIN.PATH} />
}

export default Logout
